import { makeStyles } from '@alpha/ui-lib/theme';

const useStyles = makeStyles(
  ({ typography }) => ({
    rightAlignedCtas: {
      display: 'flex',
      alignItems: 'flex-start',
    },
    cancelIcon: {
      color: '#333333',
      opacity: '50%',
    },
    submitButtonContainer: {
      marginLeft: '8px',
      '& .MuiButton-root': {
        borderRadius: '10px',
        height: '44px',
        width: '180px',
        minWidth: 'fit-content',
        fontFamily: typography.fontFamily,
        fontSize: '13px',
        letterSpacing: '0px !important',
      },
    },
  }),
  { name: 'RightAlignedCtas' },
);

export default useStyles;
